import React, { useState } from 'react';
import event01 from '../common/images/main/c-event-01.jpg';
import event02 from '../common/images/main/c-event-02_20240709.jpg';
import event03 from '../common/images/main/c-event-03_20240703_2.webp';
import event04 from '../common/images/main/c-event-04.jpg';
import event05 from '../common/images/main/RegularInclusiveFare.jpg';
import event06 from '../common/images/main/RegularSpecialFare.jpg';
import event07 from '../common/images/main/SpecialFareOnSpecificDates.jpg';
import event08 from '../common/images/main/FuelTaxInformation.jpg';
import mainBanner from '../common/images/main/mainBanner.png';
import last01 from '../common/images/main/last-item04.svg';
import last02 from '../common/images/main/last-item01.svg';
import last03 from '../common/images/main/last-item02.svg';
import last04 from '../common/images/main/last-item03.svg';
import '../common/css/indexpage.css';
import '../common/css/plugin/swiper-bundle.css';
import SaveModal from './modal/saveModal';

function IndexPage() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);

    const notOpen = () => {
        setModalContent('현재 준비 중인 서비스입니다.');
        setModalAction(() => () => setSaveStatus(true));
        setSaveStatus(false);
        return;
    };

    return (
        <main class='container'>
            <div class='inner'>
                <section className='main-banner'>
                    <div className='main-banner-title'>
                        <p className='main-banner-p'>필리핀항공 여행사 우대 사이트 - With PAL</p>
                    </div>
                    <img src={mainBanner} alt='메인이미지' className='main-banner-img' />
                </section>
                {/* 공지 사항 */}
                <section class='event info'>
                    <div class='l-inner'>
                        <div class='l-title-area'>
                            <p class='l-cata'>N O T I C E</p>
                            <h3 class='l-tit'>
                                <a href='#none'>공지사항</a>
                            </h3>
                        </div>
                        <p class='layer'></p>

                        <div class='deals_inner'>
                            <div class='swiper__wrap event-swiepr-area is-active'>
                                <div class='l-swiper swiper eventwiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden'>
                                    <div
                                        class='swiper-wrapper'
                                        id='swiper-wrapper-106fcb40224d32c14'
                                        aria-live='polite'
                                        style={{
                                            transform: 'translate3d(0px, 0px, 0px)',
                                            transitionDuration: '0ms',
                                            gap: '24px',
                                        }}
                                    >
                                        <div
                                            class='swiper-slide swiper-slide-active'
                                            role='group'
                                            aria-label='1 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/notice/reservationrules'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/notice/reservationrules'>
                                                        <p class='l-item__img'>
                                                            <img src={event01} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/notice/reservationrules'></a>
                                                        <dt class='tit'>
                                                            <a href='/notice/reservationrules'></a>
                                                            <a href='/notice/reservationrules'>
                                                                예약/발권 규정
                                                            </a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/notice/reservationrules'>
                                                                필리핀항공 예약 및 발권 시 필요한
                                                                <br />
                                                                주요 사항을 확인할 수 있습니다.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide swiper-slide-next'
                                            role='group'
                                            aria-label='2 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/notice/reissuerules'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/notice/reissuerules'>
                                                        <p class='l-item__img'>
                                                            <img src={event02} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/notice/reissuerules'></a>
                                                        <dt class='tit'>
                                                            <a href='/notice/reissuerules'></a>
                                                            <a href='/notice/reissuerules'>
                                                                재발행 규정
                                                            </a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/notice/reissuerules'>
                                                                항공권 변경 및 재발행 규정을
                                                                <br />
                                                                확인하세요.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide'
                                            role='group'
                                            aria-label='3 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/notice/paidseatsbaggagerules'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/notice/paidseatsbaggagerules'>
                                                        <p class='l-item__img'>
                                                            <img src={event03} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/notice/paidseatsbaggagerules'></a>
                                                        <dt class='tit'>
                                                            <a href='/notice/paidseatsbaggagerules'></a>
                                                            <a href='/notice/paidseatsbaggagerules'>
                                                                유료좌석/수하물 규정
                                                            </a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/notice/paidseatsbaggagerules'>
                                                                유료좌석 및 수하물 규정을
                                                                <br />
                                                                안내합니다.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide'
                                            role='group'
                                            aria-label='4 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/notice/Flightdelayinfo'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/notice/Flightdelayinfo'>
                                                        <p class='l-item__img'>
                                                            <img src={event04} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/notice/Flightdelayinfo'></a>
                                                        <dt class='tit'>
                                                            <a href='/notice/Flightdelayinfo'></a>
                                                            <a href='/notice/Flightdelayinfo'>
                                                                항공편 운항 정보
                                                            </a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/notice/Flightdelayinfo'>
                                                                항공편 지연 및 결항 정보를
                                                                <br />
                                                                확인할 수 있습니다.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* 운임 안내 */}
                <section class='event info'>
                    <div class='l-inner'>
                        <div class='l-title-area'>
                            <p class='l-cata'>P R I C E</p>
                            <h3 class='l-tit'>
                                <a href='#none'>운임 안내</a>
                            </h3>
                        </div>
                        <p class='layer'></p>

                        <div class='deals_inner'>
                            <div class='swiper__wrap event-swiepr-area is-active'>
                                <div class='l-swiper swiper eventwiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden'>
                                    <div
                                        class='swiper-wrapper'
                                        id='swiper-wrapper-106fcb40224d32c14'
                                        aria-live='polite'
                                        style={{
                                            transform: 'translate3d(0px, 0px, 0px)',
                                            transitionDuration: '0ms',
                                            gap: '24px',
                                        }}
                                    >
                                        <div
                                            class='swiper-slide swiper-slide-active'
                                            role='group'
                                            aria-label='1 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/fare/all'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/fare/all'>
                                                        <p class='l-item__img'>
                                                            <img src={event05} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/fare/all'></a>
                                                        <dt class='tit'>
                                                            <a href='/fare/all'></a>
                                                            <a href='/fare/all'>
                                                                전체 요금 보기
                                                            </a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/fare/all'>
                                                                전 노선의 운임을 한눈에 확인하세요.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide swiper-slide-next'
                                            role='group'
                                            aria-label='2 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/fare/regular'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/fare/regular'>
                                                        <p class='l-item__img'>
                                                            <img src={event06} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/fare/regular'></a>
                                                        <dt class='tit'>
                                                            <a href='/fare/regular'></a>
                                                            <a href='/fare/regular'>
                                                            정규 포괄 요금
                                                            </a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/fare/regular'>
                                                                전 노선 PCF Table 및 정규포괄요금을
                                                                확인할 수 있습니다.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide'
                                            role='group'
                                            aria-label='3 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/fare/discount'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/fare/discount'>
                                                        <p class='l-item__img'>
                                                            <img src={event07} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/fare/discount'></a>
                                                        <dt class='tit'>
                                                            <a href='/fare/discount'></a>
                                                            <a href='/fare/discount'>정규 특가 요금</a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/fare/discount'>
                                                                얼리버드, 국내선 ADD-ON 등의
                                                                <br />
                                                                특가 요금을 확인할 수 있습니다.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide'
                                            role='group'
                                            aria-label='4 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/notice/Fueltaxinfo'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/notice/Fueltaxinfo'>
                                                        <p class='l-item__img'>
                                                            <img src={event08} alt='이미지' />
                                                        </p>
                                                    </a>
                                                    <dl class='e-item__desc'>
                                                        <a href='/notice/Fueltaxinfo'></a>
                                                        <dt class='tit'>
                                                            <a href='/notice/Fueltaxinfo'></a>
                                                            <a href='/notice/Fueltaxinfo'>
                                                                유류/TAX 안내
                                                            </a>
                                                        </dt>
                                                        <dd class='sub'>
                                                            <a href='/notice/Fueltaxinfo'>
                                                                유류 할증료 및 각종 TAX 관련
                                                                <br />
                                                                정보를 안내합니다.
                                                            </a>
                                                        </dd>
                                                    </dl>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                {/* 고객 지원 */}
                <section class='event info'>
                    <div class='l-inner'>
                        <div class='l-title-area'>
                            <p class='l-cata'>S U P P O R T</p>
                            <h3 class='l-tit'>
                                <a>고객 지원</a>
                            </h3>
                        </div>
                        <p class='layer'></p>

                        <div class='deals_inner'>
                            <div class='swiper__wrap event-swiepr-area is-active'>
                                <div class='l-swiper swiper eventwiper swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden'>
                                    <div
                                        class='swiper-wrapper'
                                        id='swiper-wrapper-106fcb40224d32c14'
                                        aria-live='polite'
                                        style={{
                                            transform: 'translate3d(0px, 0px, 0px)',
                                            transitionDuration: '0ms',
                                            gap: '24px',
                                        }}
                                    >
                                        <div
                                            class='swiper-slide swiper-slide-active'
                                            role='group'
                                            aria-label='1 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/service/standbyrequest'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/service/standbyrequest'>
                                                        <p class='l-item__img last-items'>
                                                            <div className='list-item-title'>
                                                                <p className='list-item-p'>
                                                                    대기 전문 요청
                                                                </p>
                                                            </div>
                                                            <img
                                                                className='wpal-support'
                                                                src={last01}
                                                                alt='이미지'
                                                            />
                                                        </p>
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide swiper-slide-next'
                                            role='group'
                                            aria-label='2 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/service/emdticketrequest'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/service/emdticketrequest'>
                                                        <p class='l-item__img last-items'>
                                                            <div className='list-item-title'>
                                                                <p className='list-item-p'>
                                                                    EMD
                                                                    <br /> Reassociate 요청
                                                                </p>
                                                            </div>
                                                            <img
                                                                className='wpal-support'
                                                                src={last02}
                                                                alt='이미지'
                                                            />
                                                        </p>
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide'
                                            role='group'
                                            aria-label='3 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/group/bookingrequest'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/group/bookingrequest'>
                                                        <p class='l-item__img last-items'>
                                                            <div className='list-item-title'>
                                                                <p className='list-item-p'>
                                                                    단체 견적 문의
                                                                </p>
                                                            </div>
                                                            <img
                                                                className='wpal-support'
                                                                src={last03}
                                                                alt='이미지'
                                                            />
                                                        </p>
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                        <div
                                            class='swiper-slide'
                                            role='group'
                                            aria-label='4 / 4'
                                            style={{ width: '264px', marginright: '24px' }}
                                        >
                                            <div class='l-item'>
                                                <a href='/group/atrrequest'></a>
                                                <figure class='l-item__info'>
                                                    <a href='/group/atrrequest'>
                                                        <p class='l-item__img last-items'>
                                                            <div className='list-item-title'>
                                                                <p className='list-item-p'>
                                                                    ATR 발권 신청
                                                                </p>
                                                            </div>
                                                            <img
                                                                className='wpal-support'
                                                                src={last04}
                                                                alt='이미지'
                                                            />
                                                        </p>
                                                    </a>
                                                </figure>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <SaveModal
                            content={modalContent}
                            SaveBtn={saveStatus}
                            onClose={modalAction}
                        />
                    </div>
                </section>
            </div>
        </main>
    );
}

export default IndexPage;
